import React, { memo } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { IconWatch01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import * as S from './style';

interface IProps {
  timeTxt?: string;
  notiTxt?: string;
  className?: string;
  chkItem?: React.ReactNode;
  btnItem?: React.ReactNode;
  items?: React.ReactNode;
  toggleItem?: React.ReactNode;
}

const SortingBar = ({
  chkItem,
  btnItem,
  timeTxt,
  notiTxt,
  className,
  items,
  toggleItem,
}: IProps) => {
  const cName = classNameBind(['sorting-bar', className || '']);

  const text = (content: React.ReactNode) => String(content);

  return (
    <S.SortingBar className={cName}>
      {timeTxt && (
        <span className="time-txt">
          <IconWatch01 />
          {text(timeTxt)}
        </span>
      )}
      {chkItem && <span className="chk-item">{chkItem}</span>}
      {btnItem && <span className="btn-item">{btnItem}</span>}
      {items && <div className="area-sorting">{items}</div>}
      {toggleItem && <div className="area-toggle">{toggleItem}</div>}
      {notiTxt && <span className="noti-txt">{text(notiTxt)}</span>}
    </S.SortingBar>
  );
};

export default memo(SortingBar);
